// import { useState, useEffect } from "react";
// import { Table, Image, Empty } from "antd";

// const SalesProductTable = (props) => {
//   const [selectedRowKeys, setSelectedRowKeys] = useState([]);

//   const onSelectChange = (newSelectedRowKeys, newSelectedRows) => {
//     setSelectedRowKeys(newSelectedRowKeys);
//     if (props.onSelect) props.onSelect(newSelectedRows);
//   };

//   useEffect(() => {
//     if (props.data && props.data.length === 1) {
//       const singleRow = props.data[0];
//       const rowKey = singleRow?.box_number;
//       setSelectedRowKeys([rowKey]);
//       if (props.onSelect) props.onSelect(props.data);
//     }
//   }, [props.data]);

//   const columns = [
//     {
//       title: "Name",
//       dataIndex: "name",
//       key: "name",
//       width: 100,
//     },
//     {
//       title: "Description",
//       dataIndex: "description",
//       key: "description",
//       render: (text) => <div>{text}</div>,
//     },
//     {
//       title: "Amount",
//       dataIndex: "amount",
//       key: "amount",
//       render: (text) => <div>{text}</div>,
//     },
//     {
//       title: "Image",
//       dataIndex: "image",
//       key: "image",
//       render: (text, record) => (
//         <Image
//           src={record?.image ? record?.image : <Empty />}
//           alt=""
//           height={80}
//           width={100}
//         />
//       ),
//     },
//     {
//       title: "User",
//       dataIndex: "user",
//       key: "user",
//       render: (text, record) => <div>{record?.user?.name}</div>,
//     },
//   ];

//   const handlePaginationChange = (newPage, newPageSize) => {
//     if (props.PageOnchange) {
//       props.PageOnchange(newPage, newPageSize);
//     }
//   };

//   return (
//     <div>
//       <Table
//         rowClassName={(record, index) =>
//           index % 2 === 0 ? "table-row-light" : "table-row-dark"
//         }
//         columns={columns}
//         dataSource={props?.data}
//         size="small"
//         rowKey={(record) => record?.box_number}
//         pagination={true}
//       />
//     </div>
//   );
// };

// export default SalesProductTable;

import { useState, useEffect } from "react";
import { Table, Tag } from "antd";
import moment from "moment";

const SalesProductTable = (props) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys, newSelectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (props.onSelect) props.onSelect(newSelectedRows);
  };

  useEffect(() => {
    if (props.data && props.data.length === 1) {
      const singleRow = props.data[0];
      const rowKey = singleRow?.id; // Changed from box_number to id
      setSelectedRowKeys([rowKey]);
      if (props.onSelect) props.onSelect(props.data);
    }
  }, [props.data]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 100,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => <div>{text || ""}</div>,
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (text) => <div>{parseFloat(text || 0).toFixed(2)}</div>,
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
      render: (text) => <div>{parseFloat(text || 0).toFixed(2)}</div>,
    },
    {
      title: "Total Paid Amount",
      dataIndex: "totalPaidAmount",
      key: "totalPaidAmount",
      render: (text) => <div>{parseFloat(text || 0).toFixed(2)}</div>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        const statusColors =
          text === "Paid" ? "green" : text === "Partial" ? "orange" : "red";
        return <Tag color={statusColors}>{text}</Tag>;
      },
    },
    {
      title: "User",
      dataIndex: "user",
      key: "user",
      render: (text, record) => <div>{record?.user?.name || ""}</div>,
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => (
        <div>{text ? moment(text).format("YYYY-MM-DD") : ""}</div>
      ),
    },
  ];

  const handlePaginationChange = (newPage, newPageSize) => {
    if (props.PageOnchange) {
      props.PageOnchange(newPage, newPageSize);
    }
  };

  return (
    <div>
      <Table
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        columns={columns}
        dataSource={props?.data}
        size="small"
        rowKey={(record) => record?.id} // Changed from box_number to id
      />
    </div>
  );
};

export default SalesProductTable;
